import script from "./ProjectTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectTile.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectTile.vue?vue&type=style&index=0&id=0bfec9f0&lang=scss"

const __exports__ = script;

export default __exports__